"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliderArticleMain = void 0;
/**
 * 記事一覧スライダー
 */
require("swiper/css");
require("swiper/css/navigation");
require("swiper/css/pagination");
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
swiper_1.Swiper.use([modules_1.Navigation, modules_1.Autoplay, modules_1.Pagination]);
exports.sliderArticleMain = (() => {
    return {
        configure: () => {
            const sliderTarget = document.getElementById("js-sliderArticleMain");
            if (sliderTarget == null)
                return;
            /* eslint-disable @typescript-eslint/no-unused-vars */
            const swiperOptions = {
                loop: true,
                speed: 800,
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: "#js-sliderArticleMain__arrowNext",
                    prevEl: "#js-sliderArticleMain__arrowPrev",
                },
                pagination: {
                    el: "#js-sliderArticleMain__pagination",
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.12,
                        spaceBetween: 40,
                    },
                },
            };
            const swiper = new swiper_1.Swiper("#js-sliderArticleMain", swiperOptions);
            /* eslint-enable @typescript-eslint/no-unused-vars */
        },
    };
})();
